
      // This code is going to be bundled into the .js output by Vite,
      // but only in production.
      import init from '/src/app.ts'
      import pluginConfig from '/src/plugin-config.json' assert { type: 'json' }

      for (let pluginElement of document.querySelectorAll(`[data-plugin="${pluginConfig.name}"]`)) {
        init(pluginElement, JSON.parse(pluginElement.dataset.options ?? '{}'))
      }
    